// Quem tem qual perfil — a lista nominal que o Painel de Efetivo não mostra
// (lá só há contagens). Abre em "Sem perfil", que é onde está o trabalho: a meta
// é todo usuário ter um perfil.
//
// Somente leitura. GET /perfil-acesso-vinculos exige /admin-perfis e aplica o
// escopo da lotação de quem consulta; a tela não reimplementa nenhuma das duas
// regras e mostra a mensagem do backend quando ele recusa.
import React, { useCallback, useEffect, useState } from 'react';
import { MDBCard, MDBCardBody, MDBBtn, MDBTable, MDBTableHead, MDBTableBody, MDBSpinner } from 'mdbreact';
import api from '../../../services/api';

const nomeDe = (u) => [u.nome_social || u.nome, u.nome_social ? null : u.sobrenome].filter(Boolean).join(' ');

export default function VinculosPerfil({ perfis }) {
  const [perfil, setPerfil] = useState('sem');
  const [busca, setBusca] = useState('');
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState(null);

  const carrega = useCallback(async (filtroPerfil, termo) => {
    setCarregando(true);
    setErro(null);
    try {
      const params = {};
      if (filtroPerfil) params.perfil = filtroPerfil;
      if (termo.trim()) params.busca = termo.trim();
      const { data } = await api.get('/perfil-acesso-vinculos', { params });
      setDados(data);
    } catch (e) {
      const msg = e && e.response && e.response.data && e.response.data.erro;
      setErro(msg || 'Não foi possível carregar os vínculos de perfil.');
      setDados(null);
    } finally {
      setCarregando(false);
    }
  }, []);

  useEffect(() => { carrega(perfil, ''); }, [carrega]); // eslint-disable-line react-hooks/exhaustive-deps

  const aoMudarPerfil = (e) => {
    setPerfil(e.target.value);
    carrega(e.target.value, busca);
  };

  const aoBuscar = (e) => {
    e.preventDefault();
    carrega(perfil, busca);
  };

  return (
    <MDBCard className="my-3">
      <MDBCardBody>
        <h5 className="mb-1">Quem tem qual perfil</h5>
        <p className="grey-text mb-3" style={{ fontSize: '13px' }}>
          Usuários ativos da sua área de visão. Para vincular, use &quot;Aplicar a usuários&quot; no perfil.
        </p>

        <form className="d-flex flex-wrap align-items-end mb-3" onSubmit={aoBuscar}>
          <label className="mr-3 mb-2" htmlFor="vinculos-perfil" style={{ fontSize: '13px' }}>
            Perfil
            <select id="vinculos-perfil" className="browser-default custom-select d-block" value={perfil} onChange={aoMudarPerfil}>
              <option value="sem">Sem perfil</option>
              <option value="">Todos</option>
              {perfis.map((p) => (
                <option key={p.id} value={String(p.id)}>{p.nome}</option>
              ))}
            </select>
          </label>
          <label className="mr-3 mb-2" htmlFor="vinculos-busca" style={{ fontSize: '13px' }}>
            Nome
            <input
              id="vinculos-busca"
              className="form-control d-block"
              value={busca}
              maxLength={60}
              onChange={(e) => setBusca(e.target.value)}
              placeholder="buscar por nome"
            />
          </label>
          <MDBBtn size="sm" color="mdb-color" type="submit" className="mb-2" disabled={carregando}>
            Buscar
          </MDBBtn>
        </form>

        {carregando && <div className="text-center my-3"><MDBSpinner small /></div>}
        {erro && <p className="text-danger mb-0">{erro}</p>}
        {dados && !carregando && (
          <>
            <p className="mb-2" style={{ fontSize: '13px' }}>
              <strong>{dados.total.toLocaleString('pt-BR')}</strong> usuário(s) · escopo: {dados.escopo.gerencia}
              {dados.limite_atingido ? ' · lista cortada no limite; refine a busca' : ''}
            </p>
            {dados.total === 0 ? (
              <p className="grey-text mb-0">Ninguém neste filtro.</p>
            ) : (
              <MDBTable small responsive hover>
                <MDBTableHead>
                  <tr><th>Nome</th><th>Unidade</th><th>Ala</th><th>Perfil</th></tr>
                </MDBTableHead>
                <MDBTableBody>
                  {dados.usuarios.map((u) => (
                    <tr key={u.id}>
                      <td>{nomeDe(u)}</td>
                      <td>{u.gerencia}</td>
                      <td>{u.ala || '—'}</td>
                      <td>{u.perfil || <span className="text-danger">sem perfil</span>}</td>
                    </tr>
                  ))}
                </MDBTableBody>
              </MDBTable>
            )}
          </>
        )}
      </MDBCardBody>
    </MDBCard>
  );
}
